module.exports = __webpack_public_path__ + "img/bgf 2023.e3c7d439.webp";